import "../index.css";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  IconButton,
  LabelValue,
  Row,
  Tooltip,
  Typography,
} from "@/ui-kit";
import { UserRoleTag } from "@/components/columns/UserRoleTag";
import { PencilIcon } from "lucide-react";
import type { IUser } from "@/types/users";
import { PhoneUtils } from "@/utils/phone";

type IProps = {
  user: Pick<
    IUser,
    "fullName" | "role" | "phone" | "email" | "profilePicturePath"
  >;
  onEdit?: () => void;
};

export const UserOverviewCard = ({ user, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "60px";

  return (
    <Card className="profile-card" variant="layer1">
      <CardContent>
        <div className="profile-card__layout">
          <img
            className="profile-card__image"
            src={user.profilePicturePath}
            alt="User avatar"
          />
          <div className="profile-card__details">
            <Row gap={12}>
              <Typography
                as="h3"
                weight="bold"
                variant="h3"
                color="text-primary"
                text={user.fullName}
              />
              <UserRoleTag value={user.role} tagProps={{ size: "md" }} />

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="layer2"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.phone")}
                  value={PhoneUtils.format(user.phone)}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.email")}
                  value={user.email}
                  labelWidth={labelWidth}
                  canCopy
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
